const header = document.querySelector('.header')

const hideHeaderOnViewPortTriggers = document.querySelectorAll('.theme-hide-header')


// add observer to hideHeaderOnViewPortTriggers if they are in the viewport and add clas "header-hide" to body:
const observer = new IntersectionObserver((entries) => {
  const windowHeight = window.innerHeight
  const bodyHeight = document.body.getBoundingClientRect().height


  entries.forEach(entry => {
    if (entry.isIntersecting) {
      document.body.classList.add('header-hide')
    } else {
      document.body.classList.remove('header-hide')
    }
  })
}, {
  root: null,
  rootMargin: '0px',
  threshold: 0.5
})

hideHeaderOnViewPortTriggers.forEach(trigger => {
  observer.observe(trigger)
})
